




































import { Vue, Component, Watch } from 'vue-property-decorator';
import * as Moment from 'moment';
import { DateRange, extendMoment } from 'moment-range';
import { mapState } from 'vuex';
import Room from '@/models/Room.ts';

const moment = extendMoment(Moment);

@Component({
  computed: mapState({
    dateRange: (state: any) => state.dashboard.dateRange,
    lang: (state: any) => state.partner.lang,
    transitionType: (state: any) => state.dashboard.transitionType,
    isFetching: (state: any) => state.dashboard.isFetching,
  }),
})
export default class DateNavigation extends Vue {
  public dateRange: any;
  public lang: any;
  public transitionType!: string;
  private minDate: string = moment(new Date()).format('YYYY-MM-DD');
  private maxDate: string = moment().add(2, 'y').format('YYYY-MM-DD');

  public get dates(): any[] {
    const range = moment.range(this.dateRange.start, this.dateRange.end);
    return Array.from(range.by('days')).map((m: Moment.Moment, index: number) => {
      const dayUpper = m.locale(this.lang).format('ddd');
      const dayLower = m.locale(this.lang).format('DD');
      const month = m.locale(this.lang).format('MMM YYYY');
      const dayOfWeek = m.locale(this.lang).format('d');
      return {
        dayUpper,
        dayLower,
        month,
        showMonth: Number(dayLower) < 28 && (dayLower === '01' || index === 0),
        showBorder: dayLower === '01',
        isWeekend: dayOfWeek === '6' || dayOfWeek === '0',
        saturday: dayOfWeek === '6',
        monday: dayOfWeek === '1',
        date: m.format(),
      };
    });
  }

  public get disablePrev(): any {
    return moment(this.dateRange.start).isSame(this.minDate);
  }

  public get disableNext(): any {
    return moment(this.dateRange.end).isSame(this.maxDate);
  }

  public get momentStart(): Moment.Moment {
    return moment(this.dateRange.start);
  }

  public get momentEnd(): Moment.Moment {
    return moment(this.dateRange.end);
  }

  public get diff(): number {
    return this.momentEnd.diff(this.momentStart, 'days') + 1;
  }

  public handleSticky(evt: Event, el: HTMLElement): any {
    // 40px is month height
    const navOffsetTop = (this.$el as HTMLElement).offsetTop - 40;
    if (window.scrollY >= navOffsetTop) {
      el.classList.add('sticky');
    } else {
      el.classList.remove('sticky');
    }
  }

  public navigateDate(type: string) {
    let newRange: any;
    const diffStart = this.momentStart.diff(moment(), 'days');
    const diffEnd = moment().add(2, 'years').diff(this.momentEnd, 'days');

    if (type === 'prev' && diffStart < this.diff) {
      newRange = {
        start: this.minDate,
        end: moment().add(this.diff - 1, 'days').format('YYYY-MM-DD'),
      };
    } else if (type === 'next' && diffEnd < this.diff) {
      newRange = {
        start: moment().add(2, 'years').subtract(this.diff, 'days').format('YYYY-MM-DD'),
        end: this.maxDate,
      };
    } else {
      newRange = {
        start: type === 'next'
          ? this.momentStart.add(this.diff, 'days').format('YYYY-MM-DD')
          : this.momentStart.subtract(this.diff, 'days').format('YYYY-MM-DD'),
        end: type === 'next'
          ? this.momentEnd.add(this.diff, 'days').format('YYYY-MM-DD')
          : this.momentEnd.subtract(this.diff, 'days').format('YYYY-MM-DD'),
      };
    }
    this.$emit('navigateDate', newRange);
    this.$gtm.trackEvent({
      event: type === 'prev' ? 'availabilityPagePreviousDate' : 'availabilityPageNextDate',
    });
  }
}
